import { TDispatch } from '../type';
import { TPlanMigrationSource } from './planMigrationSource.type';

export const planMigrationSourceReducer = (
  state: TPlanMigrationSource,
  { type, payload }: TDispatch
): TPlanMigrationSource => {
  switch (type) {
    case 'set_plan_migration_source':
      return { ...(payload as TPlanMigrationSource) };
    case 'set_reset_plan_migration_source':
      return { isChatFocusSource: false, isChatGeneralSource: false };
    default:
      return state;
  }
};

planMigrationSourceReducer.key = 'planMigrationSource';
planMigrationSourceReducer.initialState = { isChatFocusSource: false, isChatGeneralSource: false };

export default { planMigrationSourceReducer };
